import { NotLoggedInWithGuestLinkError } from '@lucidlink/sdk';
import { broadcastMessage } from '@lucidlink/workspacemanagement';
/**
 * Global query/mutation cache `onError` handler covering all guest client queries
 * and mutations. A guest session invalidation (e.g., the link was deleted or expired,
 * or the guest was removed from the link's ACL) is announced via a broadcast message,
 * so every tab (including this one) can react and log out from the guest client.
 * See `useHandleGuestLinkBroadcast` for the reaction.
 */
export const broadcastGuestLinkLogoutOnError = (error) => {
    if (!(error instanceof NotLoggedInWithGuestLinkError)) {
        return;
    }
    broadcastMessage({
        type: 'guest-link-logout',
        payload: { linkId: error.linkId },
    });
};
